<template>
  <SharedLineItemProductForm :line="line" @save="save"/>
</template>

<script>
import {mapActions} from 'vuex';
export default {
  props: ['line'],
  methods: {
    ...mapActions(['changeOrderLine']),
    async save({start, done, boxSize, product}) {
      console.log('about to changeOrderLine');
      start();
      try{
        await this.changeOrderLine({
          line: this.line.id,
          boxSize,
          product
        });
        console.log('saved!');
        this.$emit('done');
      } catch (e) {
        console.error(e);
        done();
      }
    }
  }
}

function delay(ms) {
  return new Promise((r, e) => setTimeout(r, ms));
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/orders/LineDetailProductForm.vue